import {gql} from "@irati/utils/gql"

import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const createExportMutation = gql`
  mutation CreateExport($exportType: ExportType!) {
    createExport(exportType: $exportType) {
      exportId
      status
      progressPercent
      downloadUrl
      error
    }
  }
`

export const createExportKey = getQueryNames(createExportMutation)[0]

export {createExportMutation}
